import React from 'react';

import { IIconProps } from './constants';

export const UsersIcon = ({ height = 24, width = 24 }: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 20V18.3333C17 17.4493 16.6049 16.6014 15.9017 15.9763C15.1984 15.3512 14.2446 15 13.25 15H5.75C4.75544 15 3.80161 15.3512 3.09835 15.9763C2.39509 16.6014 2 17.4493 2 18.3333V20"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 11C11.433 11 13 9.433 13 7.5C13 5.567 11.433 4 9.5 4C7.567 4 6 5.567 6 7.5C6 9.433 7.567 11 9.5 11Z"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 20V18.2964C21.9993 17.5415 21.7044 16.8082 21.1614 16.2115C20.6184 15.6149 19.8581 15.1887 19 15"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4C17.3917 4.48404 18.5 5.5 18.5 7.5C18.5 9.5 17.3917 10.516 16 11"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
